// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"ea2a0f7c","220":"9d868a66","370":"d7c336b7","385":"5568e83f","426":"eb9b444c","463":"bd99ce1b","585":"b0d56483","594":"ce26880b","839":"2b818667","913":"61a90ff7"}[chunkId] + ".chunk.css";
};